<template lang="html">
    <div>
        <div class="inner-page" ref="page">
            <Header>
                <a class="specialBox" href="http://wap.china1904.com/wx/xybj">
<!--                    <img src="../../assets/100logo.png" class="logos">-->
                    <p>戏苑百家</p>
                </a>
<!--                <div class="head-content">-->
<!--                    <div @click="showModel"-->
<!--                         class="iconGp">-->
<!--                        <van-icon class="icon" class-prefix="iconfont" name="share" />-->
<!--                    </div>-->
<!--                    <div class="iconGp" @click="songCollect">-->
<!--                        <van-icon v-if="collectId" class="icon icon2" class-prefix="iconfont" name="collected2" />-->
<!--                        <van-icon v-else class="icon" class-prefix="iconfont" name="collect" />-->
<!--                    </div>-->
<!--                </div>-->
            </Header>
            <div class="scroll-list" :style="'height:' + scrollH + 'px'">
                <Songblock refs="songBlock" @playChange="playChange" class="play-block" :songDat="songDat[0]" :account="account" :pwd="pwd"/>
                <Authorblock class="author-block" :songDat="songDat[0]" :lyrics="songLyric[0]" />
                <Albumblock class="album-block" :albumDat="albumDat" :albumList="albumList" @goFreash="goFreash" :getFooterShow="footerShow"/>
<!--                <Search class="search"/>-->
                <Footer :getFooterShow="footerShow" />
            </div>
            <div v-show="qrcodeShow">
                <div class="modal_bg" @click="qrcodeShow=false"></div>
                <div class="modal_content another_modal" style="width: 80%;">
                    <div class="coupon_body" v-show="tostShowP==false&&creatUrl!==''">
                        <img :src="creatUrl" alt="分享图" class="coupon_img" crossorigin="anonymous" style="width: 100%;height: 100%">
                        <p class="invite_text">长按图片保存或转发</p>
                    </div>
                </div>
                <div class="empty_box"></div>
                <!--toast提示-->
                <div class="tost_bg" style="padding: 0.2rem" v-if="tostShowP">生成图片中……</div>
                <div class="creat_img" ref="imageDom">
                    <div v-for="(item,index) in songDat" :key="index">
                        <div class="albumImg">
                            <img
                                    :src="coverImage"
                                    crossOrigin="anonymous"
                            >
                        </div>
                        <div class="albumDetail">
                            <p>{{item.firstTitle}}{{item.side}}{{item.code}}</p>
                            <p>{{albumDat.firstTitle}}</p>
                            <p>{{singing}}</p>
                        </div>
                    </div>
                    <div class="shareQrcode" id="qrcode"></div>
                    <div class="logo">
                        <img src="../../assets/logo.png">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Songblock from "./src/playBlock";
    import Authorblock from "./src/authorBlock";
    import Albumblock from "./src/albumBlock";
    // import Search from "@/components/Search";
    import vEmits from "@/utils/vEmits";

    import { getSongDets,getLyrics } from "@/api/song";
    import { getAlbumDets,getAlbumList } from '@/api/album';
    import { goCollect,unCollect } from "@/api/me";
    import QRCode from 'qrcodejs2';
    import html2canvas from "html2canvas"

    export default {
        components:{
            Songblock,
            Authorblock,
            Albumblock,
            // Search
        },
        data(){
            return{
                albumId:'',
                songId:'',
                songDat:[{}],
                songLyric:[[]],
                albumDat:{},
                albumList:[],
                collectId:'',
                scrollH:'',
                songInx:'',
                shareLink:'',
                creatUrl:'',
                qcodeUrl:'',
                qrcodeImg:'',
                tostShowP:false,
                qrcodeShow:false,
                singing:'',
                coverImage:'',
                account:this.$route.query.account,
                pwd:this.$route.query.pwd,
                footerShow:1//为1时不展示footer导航
            }
        },
        computed:{

        },
        filters:{
            getText:function(e,key){
                if(e){
                    if(e[key]){
                        if(e[key][0]['显示']){
                            let names = '';
                            for(let i = 0;i < e[key].length;i++){
                                names = names + ',' + e[key][i]['显示'];
                            }
                            return names.substr(1,names.length);
                        }else{
                            if(key == '音乐分类'){
                                let arrs = e[key].split(',');
                                return arrs[arrs.length - 1];
                            }else{
                                return e[key];
                            }
                        }
                    }else{
                        return '/';
                    }
                }
            },
        },
        methods:{
            onChange:function(){

            },
            getSongDets:function(){
                let vues = this;
                getSongDets({singleIdList:[this.songId]}).then(res => {
                    vues.songDat.splice(0,1,res.materialSingleList[0]);
                    vues.collectId = res.materialSingleList[0].collectFlag;
                    res.materialSingleList[0].iab = vues.albumId;
                    for (const list of vues.songDat) {
                        vues.imageUrlToBase64(list.coverImage);  // html2canvas生成图片时，里面的部分图片需要转为base64格式，不然会不显示
                        if(JSON.parse(list.info)['演唱'] !== undefined){
                            vues.singing = JSON.parse(list.info)['演唱'][0]['显示']
                        }else{
                            vues.singing = JSON.parse(list.info)['演奏'][0]['显示']
                        }
                    }
                }).catch(errs => {
                    window.console.log(errs);
                })
            },
            getLyrics:function(){
                getLyrics({singleIdList:[this.songId]}).then(res => {
                    if(res.lyric){
                        this.songLyric.splice(0,1,JSON.parse(res.lyric));
                    }
                }).catch(errs => {
                    window.console.log(errs);
                })
            },
            getAlbumDets:function(){
                getAlbumDets({albumId:this.albumId}).then(res => {
                    this.albumDat = res.materialAlbum;
                }).catch(errs => {
                    window.console.log(errs);
                })
            },
            getAlbumList:function(){
                getAlbumList({albumId:this.albumId}).then(res => {
                    this.albumList = res.materialSingleList;
                    for(let i = 0;i < this.albumList.length;i++){
                        if(this.songId == this.albumList[i].id){
                            this.songInx = i;
                        }
                    }
                })
            },
            goFreash:function(e){
                if(e != this.songId){
                    let query = {
                        iab:this.albumId,
                        icd:e
                    };
                    this.push({
                        path:'xySong',
                        query:query
                    });
                    this.$emit('pageFrash');
                }else{
                    vEmits.$emit('show','该曲目即为当前曲目 !');
                }
            },
            playChange:function(e){
                let nextInx = 0;
                for(let i = 0;i < this.albumList;i++){
                    if(this.albumList[i].materialId == this.songId){
                        // inx = i;
                        break;
                    }
                }

                if(this.albumList.length == 1){
                    this.$refs.songBlock.rePlay();
                }else{
                    if(e == 'prev'){
                        if(this.songInx > 0){
                            nextInx = this.songInx - 1;
                        }else{
                            nextInx = this.albumList.length - 1;
                        }
                    }else if(e == 'next'){
                        if(this.songInx < this.albumList.length - 1){
                            nextInx = this.songInx + 1;
                        }else{
                            nextInx = 0;
                        }
                    }
                    this.goFreash(this.albumList[nextInx].id);
                }
            },
            songCollect:function(){
                let userId = this.$store.state.user.userId;
                let lgtype = this.$store.state.user.lgtype;
                let vues = this;
                if(userId){
                    if(this.collectId){
                        unCollect({
                            id:vues.collectId
                        }).then(res => {
                            window.console.log(res);
                            vues.collectId = '';
                            vEmits.$emit('show','已取消收藏');
                        })
                    }else{
                        goCollect({
                            materialId:vues.songId,
                            modelType:2,
                            userId:userId
                        }).then(res => {
                            vues.collectId = res.collectId;
                            vEmits.$emit('show','收藏成功');
                        })
                    }
                }else if(lgtype == 'ip'){
                    vEmits.$emit('show','非个人登录状态下无法进行收藏');
                }else{
                    vEmits.$emit('show','请先登录');
                }
            },
            pageBack:function(){
                this.go(-1);
            },
            share:function(){
                let vues = this;
                vues.$copyText(window.location.href).then(function(){
                    vEmits.$emit('show','已复制至粘贴板');
                },function(){
                })
            },

            //图片转为base64格式
            imageUrlToBase64(imageUrl) {
                //一定要设置为let，不然图片不显示
                let image = new Image();
                //解决跨域问题
                image.setAttribute('crossOrigin', 'anonymous');
                image.src = imageUrl;
                //image.onload为异步加载
                image.onload = () => {
                    var canvas = document.createElement("canvas");
                    canvas.width = image.width;
                    canvas.height = image.height;
                    var context = canvas.getContext('2d');
                    context.drawImage(image, 0, 0, image.width, image.height);
                    var quality = 0.8;
                    //这里的dataurl就是base64类型
                    var dataURL = canvas.toDataURL("image/jpeg", quality);//使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
                    this.coverImage = dataURL;
                }
            },

            // 生成分享海报
            showModel(){
                let that = this;
                let qrcodeHtml = document.getElementById('qrcode');
                qrcodeHtml.innerHTML = "";
                that.qcodeUrl = window.location.href;
                that.tostShowP = true;
                that.qrcodeShow = true;
                setTimeout(() => {
                    that.tostShowP = false;
                }, 2000);
                //生成二维码
                that.qrcodeImg = new QRCode(document.getElementById("qrcode"), {
                    text: that.qcodeUrl,
                    width: 80,
                    height: 80,
                });
                //截图
                setTimeout(() => {
                    html2canvas(that.$refs.imageDom, {
                        useCORS: true, //（图片跨域相关）
                        // allowTaint: true, //允许跨域（图片跨域相关）
                        taintTest: true, //是否在渲染前测试图片
                        width: window.screen.availWidth,
                        // height:window.screen.availHeight,
                        // windowWidth: document.scrollWidth,
                        // windowHeight: document.scrollHeight,
                        x: 0,
                        y: window.pageYOffset,
                        sacle:2, //渲染的比例尺
                    }).then((canvas) => {
                        let dataURL = canvas.toDataURL("image/png");
                        that.creatUrl = dataURL;
                        that.imgType=1
                    });
                }, 2000)
            },
        },
        created:function(){
            this.albumId = this.$route.query.iab;
            this.songId = this.$route.query.icd;
            this.getSongDets();
            this.getLyrics();
            this.getAlbumDets();
            this.getAlbumList();
            this.scrollH = document.documentElement.clientHeight - 45;
            this.shareLink = this.$route.fullName;
        }
    }
</script>

<style lang="css" scoped>
    [v-cloak]{display:none}
    .scroll-list{
        position: relative;
        overflow-y: scroll;
        overflow-x: hidden;
    }

    /* 头部 */

    .page-head{
        height:45px;
        background: white;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #f5f5f5;
    }

    .page-head .head-right{
        display: flex;
        width: 135px;
    }

    .page-head .iconGp{
        flex-shrink: 0;
        height:45px;
        width:45px;
        text-align: center;
        line-height: 45px;
    }

    .page-head .iconGp .icon{
        font-size: 21px;
    }

    .page-head .iconGp .icon2{
        color: #af2d2d;
    }

    .page-head .head-content{
        display: flex;
        align-items: center;
        flex-direction: row-reverse;
    }

    /* 播放块 */

    .play-block{
        background: white;
        padding-top: 18px;
    }

    /* 主题信息 */


    /* 专辑 */

    .album-block{
        margin-top: 6px;
        /*display: none;*/
    }

    .search{
        padding-top: 30px;
        margin-bottom: -1px;
    }

    /*分享海报*/
    .shareQrcode{
        position: absolute;
        left: 50%;
        transform: translate(-50%,0);
        bottom: 70px;
    }
    .shareQrcode img{
        width: 100%;
        height: 100%;
    }
    .logo{
        width: 100%;
        height: 57px;
        background: #000;
        position: absolute;
        bottom: 0;
        left: 0;
    }
    .logo img{
        width: 100%;
        height: 57px;
    }
    .albumDetail{
        width: auto;
        padding: 10px;
        overflow: hidden;
    }
    .albumDetail p{
        font-size: 14px;
        line-height: 15px;
        text-align: center;
    }
    .albumImg{
        width: 100%;
        height:350px;
        margin: 0 auto;
    }
    .albumImg img{
        width: 100%;
        height:350px;
    }
    .invite_text {
        text-align: center;
        margin-top:10px;
        font-size:12px;
        color: #fff;
    }
    .modal_bg {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.7);
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1000;
    }
    .coupon_body{
        width: 100%;
    }
    .modal_content {
        position: fixed;
        width: calc(100% - 2.75rem);
        height: auto;
        z-index: 1001;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }
    .modal_content .banner_modal {
        width: 100%;
        height: auto;
        border-radius: 0.5rem;
        overflow: hidden;
    }
    .modal_content .banner_modal a {
        display: block;
        width: 100%;
    }
    .modal_content .close_btn {
        text-align: center;
        margin-top: 0.75rem;
    }
    .modal_content .close_btn i {
        font-size: 1.5rem;
        color: #D2D2D2;
    }
    .tost_bg {
        top: 50%;
        left: 50%;
        position: fixed;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        border-radius: 5px;
        background: rgba(0, 0, 0, 0.7);
        color: white;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        text-align: center;
        padding: 0.5rem;
        z-index: 12;
        font-size: 16px;
    }
    .tost_bg i {
        font-size: 30px;
        color: rgba(255, 255, 255, 0.8);
        margin-bottom: 10px;
        display: block;
    }
    .tost_bg i.icon-loading:before {
        display: block;
        -webkit-transform: rotate(360deg);
        animation: rotation 2.7s linear infinite;
    }
    .tost_bg p {
        color: #fff;
        text-align: center;
        font-size: 16px;
    }
    .creat_img {
        position: fixed;
        width: 100%;
        height: 630px;
        top: 0;
        left: 0;
        z-index: -4;
    }
    .empty_box {
        width: 100% ;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        background: #fff;
        z-index: -2;
    }
    .close_modal {
        text-align: center;
        font-size: 12px !important;
    }
    .close_modal i {
        font-size: 26px !important;
        color: #fff;
    }
    .specialBox{
        display: block;
    }
    .specialBox .logos{
        width: 57.8px;
        height: 29px;
        float: left;
        margin-top: 14px;
    }
    .specialBox p{
        color: rgb(177, 53, 53);
        float: left;
        font-weight: bold;
    }
</style>
